<template>
  <ul class="v-list">
    <template v-for="(r, index) in rings">
      <middle-banner
        v-if="showMiddleBanner(index)"
        :key="`middleBanner_${ index }`"
        :middleBanner="getMiddleBanner(index)"
      />
      <ring-item
        :key="r.id"
        :r="r"
        :index="index"
        :favoritedRings="favoritedRings"
        :isFavoritedLoading="isFavoritedLoading"
        :photoMode="photoMode"
        :bgMode="bgMode"
        :productBackgrounds="productBackgrounds"
        :productBackgroundsRandom="productBackgroundsRandom"
        @favoriteClick="$emit('favoriteClick', $event, r)"
        @quickViewClick="$emit('quickViewClick', $event, r)"
      />
    </template>
  </ul>
</template>

<script>
import MiddleBanner from './MiddleBanner';
import RingItem from './RingItem';

export default {
  props: {
    rings: {
      type: Array,
      required: true,
    },
    middleBanners: {
      type: Array,
      required: true,
    },
    middleBannerPositions: {
      type: Array,
    },
    favoritedRings: {
      type: Array,
      default: [],
    },
    isFavoritedLoading: {
      type: Boolean,
      default: true,
    },
    photoMode: {
      type: String,
      required: true,
    },
    bgMode: {
      type: String,
      required: true,
    },
    isNotFiltered: {
      type: Function,
      required: true,
    },
    productBackgrounds: {
      type: Object,
      required: true,
    },
    productBackgroundsRandom: {
      type: Array,
      required: true,
    },
  },

  name: 'RingList',

  components: { RingItem, MiddleBanner },

  methods: {
    showMiddleBanner (ringIndex) {
      return this.middleBannerPositions.includes(ringIndex) &&
        this.middleBanners[this.middleBannerPositions.indexOf(ringIndex)] &&
        this.isNotFiltered()
    },

    getMiddleBanner (ringIndex) {
      return this.middleBanners[this.middleBannerPositions.indexOf(ringIndex)]
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list {
  --grid-column: 2;
  display: grid;
  grid-template-columns: repeat(var(--grid-column), 1fr);
  grid-gap: 10px;
  grid-auto-flow: dense;

  @media screen and (min-width: 600px) {
    --grid-column: 3;
  }

  @media screen and (min-width: 900px) {
    --grid-column: 3;
    grid-gap: 20px;
  }

  @media screen and (min-width: 1200px) {
    --grid-column: 4;
    grid-gap: 30px;
  }

  @media screen and (min-width: 1600px) {
    --grid-column: 6;
  }
}
</style>
